import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxSaleGroupCosmeticResponse } from './admin-box-sale-group-cosmetic.response';
import { AdminBoxSaleMissingItemPickStrategy } from '../../enums/admin-box-sale-missing-item-pick-strategy';

@jsonObject
export class AdminBoxSaleGroupResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Boolean)
  public readonly isVisibleInQuestionnaire!: boolean;

  @jsonMember(String)
  public readonly missingItemPickStrategy!: AdminBoxSaleMissingItemPickStrategy;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(AdminBoxSaleGroupCosmeticResponse)
  public readonly cosmetics!: AdminBoxSaleGroupCosmeticResponse[];
}
